<router-outlet>
    <div class="np-loader">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
</router-outlet>
